import { ConfigConstants } from '../../config/config-constants';
import { ArrayModel, ODataArrayOutModel } from './array.model';
import { ODataParticipantOutModel, ParticipantModel } from './participant.model';

export class ParticipantListModel extends ArrayModel<ParticipantModel> {
    public constructor(name: string, entries: ParticipantModel[]) {
        super(name, entries);
    }

    /**
     * Iterate over internal models array and call outmodel conversion function for each of the models
     *
     * @returns {object} the outmodel representation of this array model
     */
    public getOutModel(): ParticipantListOutModel {
        const outModel = <ParticipantListOutModel>super.getOutModel();
        const selectedParticipants = this.getSelectedParticipants();
        outModel[this.name] = selectedParticipants.map((entry) => {
            entry.shared.value = ConfigConstants.sapTrue;
            return entry.getOutModel();
        });
        return outModel;
    }

    /**
     * This function will filter participants based on isSelected flag true
     */
    public getSelectedParticipants(): ParticipantModel[] {
        return this.value.filter((participant) => participant.isSelected.value) || [];
    }
}

export interface ParticipantListOutModel extends ODataArrayOutModel {
    CrmParticipantSet: ODataParticipantOutModel[];
}
